// import React from 'react';

// const testimonials = [
//   {
//     name: "Ava R., Toronto",
//     feedback: "Systematic Career Planner helped me identify my true passion. The mentorship was truly world-class.",
//   },
//   {
//     name: "Liam D., London",
//     feedback: "Their approach is highly structured and personalized. I landed my dream job within months!",
//   },
//   {
//     name: "Sophia M., Sydney",
//     feedback: "Perfect for international students and career changers. Highly recommended.",
//   }
// ];

// const Testimonials = () => (
//   <section className="bg-blue-50 py-16">
//     <div className="text-center mb-12">
//       <h2 className="text-3xl font-bold text-blue-800">Client Testimonials</h2>
//       <p className="text-gray-600 mt-2">Here’s what people around the world say about us</p>
//     </div>
//     <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-6 px-6">
//       {testimonials.map((t, i) => (
//         <div key={i} className="bg-white p-6 rounded-lg shadow-md w-full md:w-1/3">
//           <p className="text-gray-700 italic">“{t.feedback}”</p>
//           <h4 className="text-right text-blue-700 font-semibold mt-4">– {t.name}</h4>
//         </div>
//       ))}
//     </div>
//   </section>
// );

// export default Testimonials;
import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import WaveBackground from "../backgrounds/WaveBackground";

const testimonials = [
  {
    name: "Priya S., Mumbai",
    feedback:
      "SCP helped my son choose the right stream after 10th. The structured approach gave us so much clarity — it was like a SIP for his career!",
  },
  {
    name: "Rahul M., Pune",
    feedback:
      "I was confused between Engineering and CA after 12th. The one-on-one consultation helped me make the right decision. Highly recommended!",
  },
  {
    name: "Anita D., Bangalore",
    feedback:
      "As a working professional, I was stuck in my career. SCP's career switching guidance helped me transition smoothly to a better role.",
  },
];

const Testimonials = () => (
  <section id="testimonials" className="relative bg-gradient-to-br from-blue-50 to-blue-100 py-20">
    <WaveBackground />
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
        Client Testimonials
      </h2>
      <p className="text-gray-600 mt-2">
        Here’s what people around the world say about us
      </p>
    </div>
    <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-3 px-6">
      {testimonials.map((t, i) => (
        <div
          key={i}
          className="relative bg-white rounded-2xl shadow-md p-8 transition-all 
                     duration-300 hover:shadow-xl hover:-translate-y-1"
        >
          <FaQuoteLeft className="text-blue-300 text-3xl absolute -top-4 -left-3" />
          <p className="text-gray-700 italic leading-relaxed">“{t.feedback}”</p>
          <h4 className="text-right text-blue-700 font-semibold mt-6">
            – {t.name}
          </h4>
        </div>
      ))}
    </div>
  </section>
);

export default Testimonials;
